(function () {
  "use strict";

  var QUERY = "(prefers-reduced-motion: reduce)";
  var mq = window.matchMedia ? window.matchMedia(QUERY) : null;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function reduced() {
    return !!(mq && mq.matches);
  }

  function setup(root) {
    if (root.__auSlideshowA11y) return true;
    if (
      typeof root.startAutoRotate !== "function" ||
      typeof root.clearTimer !== "function"
    ) {
      return false;
    }
    root.__auSlideshowA11y = true;

    if (root.getAttribute("data-auto-rotate") !== "true") return true;

    var btn = root.querySelector(".slideshow-carousel--pause");
    var original = root.auto_rotate;
    var paused = false;

    var apply = function (next) {
      paused = next;
      if (paused) {
        root.auto_rotate = false;
        root.clearTimer();
      } else {
        root.auto_rotate = original;
        root.startAutoRotate();
      }
      if (btn) btn.setAttribute("aria-pressed", paused ? "true" : "false");
      root.setAttribute("data-au-rotate-paused", paused ? "true" : "false");
    };

    if (btn) {
      btn.addEventListener("click", function () {
        apply(!paused);
      });
    }

    if (reduced()) apply(true);

    if (mq && mq.addEventListener) {
      mq.addEventListener("change", function () {
        apply(reduced());
      });
    }

    return true;
  }

  function boot(scope, tries) {
    var pending = false;
    slice((scope || document).querySelectorAll("slideshow-carousel")).forEach(
      function (el) {
        if (setup(el) === false) pending = true;
      }
    );
    if (pending && tries < 30) {
      requestAnimationFrame(function () {
        boot(scope, tries + 1);
      });
    }
  }

  function init() {
    boot(document, 0);
    document.addEventListener("shopify:section:load", function (e) {
      boot(e.target, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
